import { z } from 'zod';
const knownPayabliBillStatusKindSchema = z.enum([
    'canceled',
    'active',
    'sentToApproval',
    'partiallyApproved',
    'rejected',
    'approved',
    'inTransit',
    'partiallyPaid',
    'paid',
]);
const PAYABLI_BILL_STATUS_CODES = {
    canceled: -99,
    active: 1,
    sentToApproval: 2,
    partiallyApproved: 5,
    rejected: 11,
    approved: 20,
    inTransit: 50,
    partiallyPaid: 75,
    paid: 100,
};
export const PAYABLI_BILL_STATUS_LABELS = {
    canceled: 'Cancelled',
    active: 'Active',
    sentToApproval: 'Sent to Approval',
    partiallyApproved: 'Partially Approved',
    rejected: 'Rejected',
    approved: 'Approved',
    inTransit: 'In Transit',
    partiallyPaid: 'Partially Paid',
    paid: 'Paid',
};
const PAYABLI_BILL_EVENT_STATUS = new Map([
    ['BillDisApproved', 'rejected'],
    ['BillApproved', 'approved'],
    ['BillProcessing', 'inTransit'],
    ['BillPartiallyPaid', 'partiallyPaid'],
    ['BillPaid', 'paid'],
    ['BillCanceled', 'canceled'],
]);
const KNOWN_KIND_BY_CODE = new Map(knownPayabliBillStatusKindSchema.options.map((kind) => [PAYABLI_BILL_STATUS_CODES[kind], kind]));
export function payabliBillStatusFromCode(code) {
    const kind = KNOWN_KIND_BY_CODE.get(code);
    return kind ? { kind } : { kind: 'unknown', code };
}
export function payabliBillStatusFromEvent(eventName) {
    const kind = PAYABLI_BILL_EVENT_STATUS.get(eventName);
    return kind ? { kind } : undefined;
}
const TERMINAL_KINDS = new Set([
    'paid',
    'canceled',
    'rejected',
]);
export function isTerminalPayabliBillStatus(status) {
    return status.kind !== 'unknown' && TERMINAL_KINDS.has(status.kind);
}
export const TERMINAL_PAYABLI_BILL_STATUS_CODES = [...TERMINAL_KINDS].map((kind) => PAYABLI_BILL_STATUS_CODES[kind]);
export function payabliBillStatusCode(status) {
    return status.kind === 'unknown' ? status.code : PAYABLI_BILL_STATUS_CODES[status.kind];
}
export function payabliBillStatusLabel(status) {
    return status.kind === 'unknown'
        ? `Unknown (${status.code})`
        : PAYABLI_BILL_STATUS_LABELS[status.kind];
}
export const payabliBillStatusSchema = z.union([
    z.object({ kind: knownPayabliBillStatusKindSchema }),
    z.object({
        kind: z.literal('unknown'),
        code: z
            .number()
            .int()
            .refine((code) => !KNOWN_KIND_BY_CODE.has(code), {
            message: 'A documented Payabli Bill status code must use its own kind',
        }),
    }),
]);
//# sourceMappingURL=payabliBillStatus.js.map